export default __webpack_public_path__ + "static/media/content-width.68ec7b63.svg";